import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgStarOutline(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 0 18 24" {...props}>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        d="M10.202 9.72l-4.654.399c-.285.024-.517.075-.754.368.086.173.244.35.46.538l3.53 3.06-1.057 4.549c-.065.278-.089.515.116.83.19-.027.409-.123.654-.27l4-2.414 4 2.413c.245.148.463.244.827.146.032-.19.008-.426-.057-.705l-1.058-4.55 3.53-3.06c.217-.186.375-.364.395-.74-.17-.09-.403-.14-.688-.165l-4.654-.4-1.815-4.28c-.112-.264-.232-.47-.59-.606-.138.136-.258.342-.37.606l-1.815 4.28z"
      />
    </svg>
  );
}

export default tombacIcon('StarOutline')(SvgStarOutline);
